import React, {useEffect,useState} from 'react';
import bookingService from "../../../../../../services/booking.service";
import { useEyeconxStore } from "../../../../../../store/eyeconxStore";
import Loading from "../../../../../common/Loading";

const DoctorsList = ({ onDoctorSelect }) => {
    const clinicId = useEyeconxStore((state) => state.user.clinicId);
    const [doctors, setDoctors] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchDoctors();
    },[])

    const fetchDoctors = async () => {
        try{
            const res = await bookingService.getDoctorList(clinicId);
            setDoctors(res.data);
            setIsLoading(false);
            console.log(res.data);
        }catch(error){
            console.log(error);
        }finally{
            setIsLoading(false);
        }
    }

    const getInitials = (name) => {
        if (!name) return 'DR';
        return name
            .split(' ')
            .map(part => part[0])
            .join('')
            .toUpperCase()
            .slice(0, 2);
    }

    const getStatusBadge = (isActive) => {
        return isActive ?
            <span className="badge bg-success">Active</span> :
            <span className="badge bg-secondary">Inactive</span>;
    }

    if(isLoading){
        return <Loading/>
    }

    return (
        <div className="card ">

            <div className="card-body">
                <h4 className="card-title mb-0 py-3">
                    <i className="bi bi-person-badge me-2"></i>
                    Doctors List
                </h4>
                {doctors && doctors.length > 0 ? (
                    <div className="list-group list-group-flush">
                        {doctors.map((doctor,index) => (
                            <div key={index} className="list-group-item list-group-item-action d-flex align-items-center py-3">
                                <div className="flex-shrink-0 me-3">
                                    {doctor.photoUrl ? (
                                        <img
                                            src={doctor.photoUrl}
                                            alt={doctor.name}
                                            className="rounded-circle"
                                            style={{width: '50px', height: '50px', objectFit: 'cover'}}
                                        />
                                    ) : (
                                        <div
                                            className="rounded-circle d-flex align-items-center justify-content-center bg-primary text-white fw-bold"
                                            style={{width: '50px', height: '50px'}}
                                        >
                                            {getInitials(doctor.name)}
                                        </div>
                                    )}
                                </div>
                                <div className="flex-grow-1">
                                    <h6 className="mb-1 fw-bold text-dark">{doctor.name || 'Unknown Doctor'}</h6>
                                    <div className="d-flex align-items-center">
                                        {getStatusBadge(doctor.isActive)}

                                    </div>
                                </div>
                                <div className="flex-shrink-0">
                                    <button
                                        className="btn btn-sm btn-outline-secondary border-0"
                                        onClick={() => onDoctorSelect(doctor)}
                                    >
                                        <i className="bi bi-gear fs-6"></i>
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="text-center py-5 text-muted">
                        <i className="bi bi-person-x fs-1 d-block mb-2"></i>
                        No doctors found
                    </div>
                )}
            </div>
        </div>
    )
}

export default DoctorsList;